export default defineNuxtRouteMiddleware(async (_to, from) => {
	const nuxtApp = useNuxtApp()
	const localePath = useLocalePath()
	const isLogged = useCookie('is_logged')
	const userStore = useUserStore()

	if (!isLogged.value) {
		return navigateTo({ path: localePath('/'), query: { redirectAfter: from.fullPath } })
	}
	try {
		await userStore.fetchUser()
	} catch (error) {
		logger.log(error)
		nuxtApp.runWithContext(() => userStore.logout())
	}
})
